(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-shape-bar"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-shape-filter-link]');

    if (!link) return;

    event.preventDefault();

    const url = new URL(link.href);
    if (!link.matches('[aria-current="true"]')) {
      url.searchParams.delete(link.dataset.filterParam);
      url.searchParams.append(link.dataset.filterParam, link.dataset.filterValue);
    }
    url.hash = 'product-grid';
    window.location.assign(url.toString());
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-pdp-product-upsell"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const upsell = document.querySelector('[data-custom-upsell-product]');
    const product = upsell?.closest('.product');
    const mediaWrapper = product?.querySelector('.product__media-wrapper');
    const gallery = product?.querySelector('media-gallery');
    const infoWrapper = product?.querySelector('.product__info-wrapper');
    const desktopQuery = window.matchMedia('(min-width: 990px)');

    if (!mediaWrapper || !gallery || !infoWrapper) return;

    const updateGalleryBoundary = () => {
      if (!desktopQuery.matches) {
        mediaWrapper.style.removeProperty('--ring-gallery-boundary-height');
        return;
      }

      const wrapperTop = mediaWrapper.getBoundingClientRect().top + window.scrollY;
      const infoRect = infoWrapper.getBoundingClientRect();
      const infoBottom = infoRect.top + window.scrollY + infoRect.height;
      const galleryHeight = gallery.getBoundingClientRect().height;
      const boundaryGap = 24;
      const boundaryHeight = Math.max(galleryHeight, infoBottom - wrapperTop - boundaryGap);

      mediaWrapper.style.setProperty('--ring-gallery-boundary-height', `${boundaryHeight}px`);
    };

    updateGalleryBoundary();
    window.addEventListener('load', updateGalleryBoundary, { once: true });
    window.addEventListener('resize', updateGalleryBoundary);
    desktopQuery.addEventListener('change', updateGalleryBoundary);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-engraving-note"] && !Shopify.designMode) return;
  try {
    const initializeStickyEngravingNotes = () => {
    const desktop = window.matchMedia('(min-width: 990px)');
    const tracks = [...document.querySelectorAll('.product__media-wrapper > .ss-gallery-engraving-track')];
    const update = () => {
      tracks.forEach((track) => {
        const gallery = track.parentElement.querySelector('media-gallery');
        const note = track.querySelector('.ss-gallery-engraving-note');
        if (!gallery || !note || !desktop.matches || getComputedStyle(gallery).position !== 'sticky') {
          track.removeAttribute('data-sticky-note');
          return;
        }
        track.style.setProperty('--ss-gallery-height', gallery.getBoundingClientRect().height + 'px');
        track.style.setProperty('--ss-note-height', note.getBoundingClientRect().height + 'px');
        track.style.setProperty('--ss-gallery-top', getComputedStyle(gallery).top);
        track.setAttribute('data-sticky-note', '');
      });
    };
    const observer = new ResizeObserver(update);
    tracks.forEach((track) => {
      const gallery = track.parentElement.querySelector('media-gallery');
      if (gallery) observer.observe(gallery);
      const note = track.querySelector('.ss-gallery-engraving-note');
      if (note) observer.observe(note);
    });
    window.addEventListener('resize', update, { passive: true });
    window.addEventListener('load', update, { once: true });
    desktop.addEventListener('change', update);
    update();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeStickyEngravingNotes, { once: true });
  } else {
    initializeStickyEngravingNotes();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-trust-bar"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const textLink = document.querySelector('[data-product-text-us]');
    const productButtons = document.querySelector('.product:not(.featured-product) .product-form__buttons');

    if (!textLink || !productButtons) return;

    productButtons.appendChild(textLink);
    window.dispatchEvent(new Event('resize'));
  });
  } catch(e) { console.error(e); }
})();

})();
